export enum PaymentFrequencies {
    Monthly = "Monthly",
    SemiAnnual = "Semi-Annual",
    Quarterly = "Quarterly",
    Annual = "Annual"
  }
  
  //mobile Ms1 payment frequencies 
  export enum PaymentFrequenciesMobile {
    Monthly = "Monthly",
    Biannually = "Biannually",
    Quarterly = "Quarterly",
    Annually = "Annually"
  } 
